import { getCity } from '@src/containers/Session/selectors/getCity';
import { getSitename } from '@src/containers/Session/selectors/getSitename';
import { createSelector } from 'reselect';

export const getListingDefaultDescription = createSelector(
	getSitename,
	getCity,
	(sitename, city) => {
		const cityName = city?.name3;
		return `Поиск площадок и пространств в ${cityName} по выгодным ценам на ${sitename}. Лучшие предложения по аренде на любое мероприятие. Бронирование на сайте.`;
	},
);
